export default {
  create: '创建',
  review: '复核',
  approve: '审批',
  approved: '已审批',
  creator: '创建人',
  submitter: '提交者',
  reviewer: '复核者',
  approver: '审批者',
  create_new_payment: '创建新付款',
  new_payment: '新建付款',
  edit_payment: '编辑付款',
  payment_details: '付款详情',
  create_payment_disbursement: '创建付款',
  create_small_value_payment: '创建小额付款',
  create_large_value_payment: '创建大额付款',
  large_payment_min_amount: '金额不能低于 200,000,001',
  large_payment_max_amount: '金额不能超过 300,000,000',
  standard_payment_min_amount: '单笔金额不能低于 {amount}',
  single_disbursement: '单笔付款',
  small_value_payment: '小额付款',
  batch_disbursement: '批量小额付款',
  single_payment_details: '单笔付款详情',
  recipient_account_number: '收款人账号',
  batch_payment_details: '批量付款详情',
  excel_worksheet_template_excel: '表格模板',
  download_template: '下载模板',
  single_payout_payment_type: '付款类型',
  business_detail: '业务详情',
  new_batch_small_disbursement: '新建批量小额付款',
  first_things_first: '首要之事',
  submit_batch_ease: '提交批量付款步骤',
  step_1_title: '下载最新模板:',
  step_1_content: '确保您目前使用的是最新的批量付款模板文件，您可以直接从上面按钮进行下载。',
  step_2_title: '填写您的信息:',
  step_2_content: '填写模板中的付款详细信息,包括收款人信息和金额等',
  step_3_title: '上传和提交:',
  step_3_content: '上传完成的模板以启动批量付款流程。',
  step_4_title: '下载结果:',
  step_4_content: '处理完成后,您可以在侧边栏的"批次上传记录"的列表点击进行下载结果报告。'
}
